import { render, staticRenderFns } from "./SlaveryStatement.vue?vue&type=template&id=14081c97&scoped=true"
import script from "./SlaveryStatement.vue?vue&type=script&lang=js"
export * from "./SlaveryStatement.vue?vue&type=script&lang=js"
import style0 from "./SlaveryStatement.vue?vue&type=style&index=0&id=14081c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14081c97",
  null
  
)

export default component.exports